import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Slovenia() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Slovenia') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [vatId, setVatId] = useState('');
    const [contactDetails, setContactDetails] = useState('');
    const [donor, setDonor] = useState('');
    const [invoice, setInvoice] = useState('');
    const [national, setNational] = useState('');

    const [checkBox1, setCheckBox1] = useState(false);
    const [checkBox2, setCheckBox2] = useState(false);
    const [checkBox3, setCheckBox3] = useState(false);
    const [checkBox4, setCheckBox4] = useState(false);

    const [showDropdown, setShowDropdown] = useState(false);

    const [serviceTypes, setServiceTypes] = useState({
        broadband: false,
        ipTelephony: false,
        ipTv: false,
        email: false,
        domain: false,
        other: false
    });

    const updateServiceType = (key, value) => {
        const updated = { ...serviceTypes, [key]: value };
        setServiceTypes(updated);

        const anySelected = Object.values(updated).some(v => v);

        setValidationStates(prev => ({
            ...prev,
            serviceType: anySelected
        }));
    };

    const [date, setDate] = useState('');
    const [place, setPlace] = useState('');
    const [signature, setSignature] = useState('');
    const [opName, setOpName] = useState('');
    const [sessionId, setSessionId] = useState('');

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONDATA = form;

        setName(JSONDATA?.country?.clientDetails?.Name ?? '');
        setAddress(JSONDATA?.country?.clientDetails?.Address ?? '');
        setVatId(JSONDATA?.country?.clientDetails?.VatId ?? '');
        setContactDetails(JSONDATA?.country?.clientDetails?.ContactDetails ?? '');
        setDonor(JSONDATA?.country?.clientDetails?.Donor ?? '');
        setInvoice(JSONDATA?.country?.clientDetails?.Invoice ?? '');
        setNational(JSONDATA?.country?.clientDetails?.National ?? '');
        setCheckBox1(JSONDATA?.country?.clientDetails?.CheckBox1 ?? false);
        setCheckBox2(JSONDATA?.country?.clientDetails?.CheckBox2 ?? false);
        setCheckBox3(JSONDATA?.country?.clientDetails?.CheckBox3 ?? false);
        setCheckBox4(JSONDATA?.country?.clientDetails?.CheckBox4 ?? false);

        const savedServiceType = JSONDATA?.country?.clientDetails?.ServiceType ?? {};
        setServiceTypes(savedServiceType);
        setShowDropdown(JSONDATA?.country?.clientDetails?.CheckBox4);

        setDate(JSONDATA?.country?.clientDetails?.Date ?? '');
        setPlace(JSONDATA?.country?.clientDetails?.Place ?? '');
        setSignature(JSONDATA?.country?.clientDetails?.Signature ?? '');
        setOpName(JSONDATA?.country?.clientDetails?.OpName ?? '');
        setSessionId(JSONDATA?.country?.clientDetails?.SessionId ?? '')
    };
    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Slovenia",
            "clientDetails": {
                "Name": name,
                "Address": address,
                "VatId": vatId,
                "ContactDetails": contactDetails,
                "Donor": donor,
                "Invoice": invoice,
                "National": national,
                "CheckBox1": checkBox1,
                "CheckBox2": checkBox2,
                "CheckBox3": checkBox3,
                "CheckBox4": checkBox4,
                "ServiceType": serviceTypes,
                "Date": date,
                "Place": place,
                "Signature": signature,
                "OpName": opName,
                "SessionId": sessionId
            },
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);
    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        e.preventDefault();

        let validationErrors = {};

        // Basic validations
        if (!name) {
            validationErrors.name = 'Please fill in Name';
        }

        if (!address) {
            validationErrors.address = 'Please fill in Address';
        }

        if (!vatId) {
            validationErrors.vatId = 'Please fill in VAT ID';
        }

        if (!contactDetails) {
            validationErrors.contactDetails = 'Please fill in contact Details';
        }

        if (!date) {
            validationErrors.date = 'Please fill in Date';
        }

        if (!place) {
            validationErrors.place = 'Please fill in Place';
        }

        if (!signature) {
            validationErrors.signature = 'Please fill in Signature';
        }

        // Checkbox validation (ONLY ONE must be selected)
        // Group 1 validation (checkbox 1 & 2)
        if (!checkBox1 && !checkBox2) {
            validationErrors.checkBoxGroup1 = 'Please select one option from first group';
        } else if (checkBox1 && checkBox2) {
            validationErrors.checkBoxGroup1 = 'Please select only one option from first group';
        }

        // Group 2 validation (checkbox 3 & 4)
        if (!checkBox3 && !checkBox4) {
            validationErrors.checkBoxGroup2 = 'Please select one option from second group';
        } else if (checkBox3 && checkBox4) {
            validationErrors.checkBoxGroup2 = 'Please select only one option from second group';
        }

        if (checkBox4) {
            const anySelected = Object.values(serviceTypes).some(v => v);

            if (!anySelected) {
                validationErrors.serviceType = 'Please select at least one service type';
            }

            setValidationStates(prev => ({
                ...prev,
                serviceType: anySelected
            }));
        }

        // Reset checkbox validation when valid
        if ((checkBox1 || checkBox2) && !(checkBox1 && checkBox2)) {
            setValidationStates(prev => ({
                ...prev,
                checkBox: true
            }));
        }

        if ((checkBox3 || checkBox4) && !(checkBox3 && checkBox4)) {
            setValidationStates(prev => ({
                ...prev,
                checkBoxGroup2: true
            }));
        }

        // Check if any validation errors exist
        if (Object.keys(validationErrors).length > 0) {

            // Update validation states
            setValidationStates(prevState => {
                const updated = { ...prevState };
                Object.keys(validationErrors).forEach(key => {
                    updated[key] = false;
                });
                return updated;
            });

            const firstErrorKey = Object.keys(validationErrors)[0];
            const firstErrorMessage = validationErrors[firstErrorKey];

            let elementToScroll = null;

            if (firstErrorKey === 'checkBoxGroup1') {
                elementToScroll = document.getElementById('checkBox1');
            } else if (firstErrorKey === 'checkBoxGroup2') {
                elementToScroll = document.getElementById('checkBox3');
            } else {
                elementToScroll = document.getElementById(firstErrorKey);
            }

            if (elementToScroll) {
                elementToScroll.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }

            toast.error(firstErrorMessage);
            return;
        }

        // Check validationStates (existing logic)
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                if (key === 'serviceType' && !checkBox4) {
                    return false; // ✅ ignore when checkbox4 not selected
                }
                return value === false;
            })
            .map(([key]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct.\n${falseKeys}`);

            let elem;

            if (falseKeys[0] === 'checkBox') {
                elem = document.getElementById('checkBox1');
            } else {
                elem = document.getElementById(falseKeys[0]);
            }
            if (elem) {
                elem.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }

            return;
        }

        // Proceed with submission
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);

            const a = document.createElement('a');
            a.href = url;
            a.download = name + '-LOA.docx';

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file:', error);
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }
    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    // ----------------------------------------------SAVE--------------------------------------------------//

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {

                if (key === 'serviceType') {
                    if (!checkBox4) return false; //ignore when not needed
                    const anySelected = Object.values(serviceTypes).some(v => v);
                    return !anySelected;
                }

                const element = document.getElementById(key);

                if (!element) return false;

                if (element.type === 'checkbox') {
                    return value === false;
                }

                return value === false && element.value.trim() !== '';
            })
            .map(([key]) => key);

        if (falseKeys.length > 0) {
            let elem;

            if (falseKeys[0] === 'checkBox') {
                elem = document.getElementById('checkBox1');
            } else {
                elem = document.getElementById(falseKeys[0]);
            }
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                <Container>
                    <p><strong>REQUEST FOR TRANSFER OF SUBSCRIPTION NUMBER</strong></p> <br></br>

                    <h2 className='heading'>Information about the current subscriber of the telephone connection</h2> <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Name/Surname*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id='name'
                                value={name}
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter subscriber name.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Address*</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id='address'
                                value={address}
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Enter address.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('vatId')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Vat ID*</label> <br />
                            <input
                                onChange={(e) => setVatId(e.target.value)}
                                type="text"
                                id='vatId'
                                value={vatId}
                                placeholder=""
                                className={`inputbox ${validationStates.vatId === false ? 'error' : ''}`}
                                onBlur={() => validateInput('vatId', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'vatId' && (
                                <div className="hover-description">
                                    Enter VAT ID.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('contactDetails')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Contact Details*</label> <br />
                            <input
                                onChange={(e) => setContactDetails(e.target.value)}
                                type="text"
                                id='contactDetails'
                                value={contactDetails}
                                placeholder=""
                                className={`inputbox ${validationStates.contactDetails === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contactDetails', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'contactDetails' && (
                                <div className="hover-description">
                                    Enter phone number/email.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('donor')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Donor</label> <br />
                            <input
                                onChange={(e) => setDonor(e.target.value)}
                                type="text"
                                id='donor'
                                value={donor}
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'donor' && (
                                <div className="hover-description">
                                    Enter name.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('invoice')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Invoice Number (Donor)</label> <br />
                            <input
                                onChange={(e) => setInvoice(e.target.value)}
                                type="text"
                                id='invoice'
                                value={invoice}
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'invoice' && (
                                <div className="hover-description">
                                    Enter number.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>National (characteristic) Number/N(S)N</label> <br />
                            <input
                                onChange={(e) => setNational(e.target.value)}
                                type="text"
                                id='national'
                                value={national}
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Please select one of this:</h2> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('checkBox1')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <input
                                    type="checkbox"
                                    id="checkBox1"
                                    checked={checkBox1}
                                    className={
                                        validationStates.checkBoxGroup1 === false && !checkBox1 && !checkBox2
                                            ? 'error'
                                            : ''
                                    }
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setCheckBox1(checked);

                                        if (checked) setCheckBox2(false);

                                        setValidationStates(prev => ({
                                            ...prev,
                                            checkBoxGroup1: true
                                        }));
                                    }}
                                />

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="checkBox1" style={{ margin: 0 }}>
                                        Request for TERMINATION of the subscription relationship with the number provider operator (DONOR):
                                    </label>

                                    {hoveredField === 'checkBox1' && (
                                        <div style={{ marginTop: '4px', fontSize: '14px', color: '#666' }}>
                                            if accepted, please check the box.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('checkBox2')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <input
                                    type="checkbox"
                                    id="checkBox2"
                                    checked={checkBox2}
                                    className={
                                        validationStates.checkBoxGroup1 === false && !checkBox1 && !checkBox2
                                            ? 'error'
                                            : ''
                                    }
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setCheckBox2(checked);

                                        if (checked) setCheckBox1(false);

                                        setValidationStates(prev => ({
                                            ...prev,
                                            checkBoxGroup1: true
                                        }));
                                    }}
                                />

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="checkBox2" style={{ margin: 0 }}>
                                        Request for MAINTENANCE of the relationship with the number provider operator (DONOR)
                                    </label>

                                    {hoveredField === 'checkBox2' && (
                                        <div style={{ marginTop: '4px', fontSize: '14px', color: '#666' }}>
                                            if accepted, please check the box.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Please select one of the options:</h2> <br></br>

                    <Row>
                        <Col>
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="checkBox3"
                                    checked={checkBox3}
                                    className={
                                        validationStates.checkBoxGroup2 === false && !checkBox3 && !checkBox4
                                            ? 'error'
                                            : ''
                                    }
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setCheckBox3(checked);

                                        if (checked) {
                                            setCheckBox4(false);
                                            setShowDropdown(false); // ensure dropdown only shows for checkbox4
                                            setServiceTypes({
                                                broadband: false,
                                                ipTelephony: false,
                                                ipTv: false,
                                                email: false,
                                                domain: false,
                                                other: false
                                            });
                                        }

                                        setValidationStates(prev => ({
                                            ...prev,
                                            checkBoxGroup2: true,
                                            serviceType: true
                                        }));
                                    }}
                                />
                                <label htmlFor="checkBox3">
                                    I want to TERMINATE the existing subscription for broadband service by switching to the new provider Username / contract number / customer code
                                </label>
                            </div>
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('checkBox4')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <input
                                    type="checkbox"
                                    id="checkBox4"
                                    checked={checkBox4}
                                    className={
                                        validationStates.checkBoxGroup2 === false && !checkBox3 && !checkBox4
                                            ? 'error'
                                            : ''
                                    }
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setCheckBox4(checked);

                                        if (checked) {
                                            setCheckBox3(false);
                                            setShowDropdown(true);
                                        } else {
                                            setShowDropdown(false);
                                            setServiceTypes({
                                                broadband: false,
                                                ipTelephony: false,
                                                ipTv: false,
                                                email: false,
                                                domain: false,
                                                other: false
                                            });
                                        }

                                        setValidationStates(prev => ({
                                            ...prev,
                                            checkBoxGroup2: true
                                        }));
                                    }}
                                />

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="checkBox4" style={{ margin: 0 }}>
                                        I want to MAINTAIN an existing subscription with my current service provider for:
                                    </label>

                                    {hoveredField === 'checkBox4' && (
                                        <div style={{ marginTop: '4px', fontSize: '14px', color: '#666' }}>
                                            If yes, check box and choose one of the options.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>

                        <Col>
                            {showDropdown && (
                                <div style={{ marginTop: '20px' }} id="serviceType">
                                    <label
                                        className={
                                            validationStates.serviceType === false &&
                                                !Object.values(serviceTypes).some(v => v)
                                                ? 'error'
                                                : ''
                                        }
                                    >
                                        Select Service Type *
                                    </label>

                                    <div className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            checked={serviceTypes.broadband}
                                            className={
                                                validationStates.serviceType === false &&
                                                    !Object.values(serviceTypes).some(v => v)
                                                    ? 'error'
                                                    : ''
                                            }
                                            onChange={(e) => updateServiceType('broadband', e.target.checked)}
                                        />
                                        <label>Broadband services</label>
                                    </div>

                                    <div className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            checked={serviceTypes.ipTelephony}
                                            className={
                                                validationStates.serviceType === false &&
                                                    !Object.values(serviceTypes).some(v => v)
                                                    ? 'error'
                                                    : ''
                                            }
                                            onChange={(e) => updateServiceType('ipTelephony', e.target.checked)}
                                        />
                                        <label>IP telephony</label>
                                    </div>

                                    <div className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            checked={serviceTypes.ipTv}
                                            className={
                                                validationStates.serviceType === false &&
                                                    !Object.values(serviceTypes).some(v => v)
                                                    ? 'error'
                                                    : ''
                                            }
                                            onChange={(e) => updateServiceType('ipTv', e.target.checked)}
                                        />
                                        <label>IP TV</label>
                                    </div>

                                    <div className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            checked={serviceTypes.email}
                                            className={
                                                validationStates.serviceType === false &&
                                                    !Object.values(serviceTypes).some(v => v)
                                                    ? 'error'
                                                    : ''
                                            }
                                            onChange={(e) => updateServiceType('email', e.target.checked)}
                                        />
                                        <label>Email</label>
                                    </div>

                                    <div className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            checked={serviceTypes.domain}
                                            className={
                                                validationStates.serviceType === false &&
                                                    !Object.values(serviceTypes).some(v => v)
                                                    ? 'error'
                                                    : ''
                                            }
                                            onChange={(e) => updateServiceType('domain', e.target.checked)}
                                        />
                                        <label>Domain</label>
                                    </div>

                                    <div className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            checked={serviceTypes.other}
                                            className={
                                                validationStates.serviceType === false &&
                                                    !Object.values(serviceTypes).some(v => v)
                                                    ? 'error'
                                                    : ''
                                            }
                                            onChange={(e) => updateServiceType('other', e.target.checked)}
                                        />
                                        <label>Other</label>
                                    </div>
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <Container>
                    <p><strong>The Client guarantees that the information provided in the request is accurate and true.</strong></p> <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Date*</label> <br />
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date} // Automatically set the current date
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Enter date.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('place')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Place*</label> <br />
                            <input
                                onChange={(e) => setPlace(e.target.value)}
                                type="text"
                                id='place'
                                value={place}
                                placeholder=""
                                className={`inputbox ${validationStates.place === false ? 'error' : ''}`}
                                onBlur={() => validateInput('place', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'place' && (
                                <div className="hover-description">
                                    Enter location.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('signature')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Signature/Stamp of the legal entity*</label> <br />
                            <input
                                onChange={(e) => setSignature(e.target.value)}
                                type="text"
                                id='signature'
                                value={signature}
                                placeholder=""
                                className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature', /[a-zA-Z0-9]/)}
                            />
                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Enter signature.
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br><br></br>

                    <p><strong>OPERATOR RECIPIENT OF THE NATIONAL NUMBER (recipient) Voxbone SA.</strong></p>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter('opName')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Name</label> <br />
                            <input
                                onChange={(e) => setOpName(e.target.value)}
                                type="text"
                                id='opName'
                                value={opName}
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'opName' && (
                                <div className="hover-description">
                                    Enter name.
                                </div>
                            )}
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('sessionId')}
                            onMouseLeave={handleMouseLeave}>
                            <label>Session ID</label> <br />
                            <input
                                onChange={(e) => setSessionId(e.target.value)}
                                type="text"
                                id='sessionId'
                                value={sessionId}
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'sessionId' && (
                                <div className="hover-description">
                                    Enter number.
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    {/* <Button variant="primary" type="autofill" onClick={autofill}>Autofill</Button> */}
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Slovenia;